import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'bd-link-external',
    template: `
      <a [href]="link()"
         target="_blank"
         rel="noopener"
         [attr.aria-label]="label() ?? null"
         [attr.title]="label() ?? null">
          <ng-content>
          </ng-content>
      </a>
  `,
    styles: [`

  `],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdLinkExternalComponent {
    link = input<string | undefined>(undefined);
    /** Accessible name for the link; without it, icon-only content leaks
     * its ligature text (e.g. "open_in_new") as the announced name. */
    label = input<string | undefined>(undefined);
}
